import {
  Box,
  Dialog,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";

import BreadcrumbsComponent from "../component/base/Breadcrumbs.component";
import {
  ContentCopy,
  Edit,
  QrCodeScannerOutlined,
  Refresh,
} from "@mui/icons-material";
import AddNewUserComponent from "../component/app/admin/dealership/AddNewUser.component";
import QRCodeUtils from "./qrcode";
import DealershipStyles from "./../component/app/admin/dealership/Dealership.styles";
import { QRPageStyle } from "./Styles.utils";
import { useRef, useState } from "react";
import { appUrl, capitalizeFirstLetter, TYPE } from "./Utils";
import Theme from "./Theme";
import { InputValidation } from "./InputValidationRegex";
import { useReactToPrint } from "react-to-print";
import AppButton from "../component/base/AppButton.component";
import AddNewUserDialog from "../component/app/admin/dealership/dialog/dialogBody/AddNewUser.dialog";
import HocPopup from "../hoc/hocPopup";

const ManageUsersTable = ({ input,dialog }) => {
  
  const {
    breadcrumb,
    employees,
    dealership,
    refetch,
    
    isAdminModule = true,
  } = input;
  const printRef = useRef();

  const [refreshChild, setRefreshChild] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [printUser, setPrintUser] = useState(null);

  const handleButtonClick = () => {
    setRefreshChild(true);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: QRPageStyle,
  });


  console.log("Employees", employees);

  const printHandler = async (user, dealership) => {
    setPrintUser({
      user: user,
      dealership: dealership,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <BreadcrumbsComponent {...breadcrumb} />
<AppButton
  sx={{
    width: {
      xs: "50%",
      sm: "25%",
      md: "12%",
      lg: "12%",
    },
    mr: 3,
  }}
  buttonText={"CREATE / IMPORT"}
  clickHandler={() => {
    dialog({
      open: true,
      bodyType: TYPE.CREATE_USER,
      body: <AddNewUserDialog />,
      maxWidth: "lg",
   
      // PaperProps: {
      //   sx: {
  
      //   }
      // }
    });
  }}
  size="medium"
  variant="contained"
/>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "1%",
          // bgcolor: "red",
          overflow: "hidden",
          p: 1,
        }}
      >
        <Paper
          sx={{
            width: {
              xs: "100%", // mobile
              sm: "100%", // small screens
              md: "99%", // medium and up
              lg: "99%",
            },
            height:
              window.innerHeight >= 1440
                ? "100vh"
                : window.innerHeight >= 1050
                ? "80vh"
                : window.innerHeight >= 900
                ? "80vh"
                : "75vh",
            boxShadow:
              "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
            borderRadius: "14px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Table stickyHeader sx={{ tableLayout: "fixed" }}>
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                backgroundColor: "#F4F6F8",
                zIndex: 1,
                "& .MuiTableCell-root": {
                  padding: "8px 8px",
                  fontSize: "0.875rem",
                },
              }}
            >
              {/* First Row: Main Headers */}
              <TableRow>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "20px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                ></TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "30px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Employee Code
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "50px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Full Name
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "50px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "60px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Mobile
                </TableCell>
                {/* {dealership?.crm_user_status && ( */}
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "30px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  URL
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "30px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  QR
                </TableCell>
                {/* <TableCell
                  rowSpan={1}
                  sx={{
                    width: "30px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Target
                </TableCell> */}
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "42px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Completed
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "30px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  rowSpan={1}
                  sx={{
                    width: "40px",
                    ...DealershipStyles.tableCell,
                    textAlign: "center",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      handleButtonClick();
                      refetch();
                    }}
                    edge="start"
                  >
                    {<Refresh />}
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {employees?.length > 0 ? (
                employees?.map((user) => (
                  <>
                    <TableRow key={user.id}>
                      {/* Icon Cell */}
                      <TableCell align="center" sx={{ border: "none" }}>
                        <GroupIcon
                          sx={{
                            color:
                               user?.role?.toLowerCase().trim() === "manager"
                                ? Theme.palette.primary.main
                                : "transparent",
                            width: "20px",
                          }}
                        />
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={DealershipStyles.tableCellStyle}
                      >
                        <span>{user.employee_code}</span>
                      </TableCell>

                      {/* Full Name Cell with Tooltip and Truncation */}
                      <TableCell
                        align="center"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "10ch",
                          border: "none",
                        }}
                      >
                        <Tooltip
                          title={`${user.first_name} ${user.last_name}`}
                          placement="top"
                        >
                          <span>
                            {`${capitalizeFirstLetter(
                              user.first_name
                            )} ${capitalizeFirstLetter(user.last_name)}`}
                          </span>
                        </Tooltip>
                      </TableCell>

                      {/* Email Cell */}
                      <TableCell
                        align="center"
                        sx={DealershipStyles.tableCellStyle}
                      >
                        <Tooltip title={user.email} placement="top">
                          <span>{user.email}</span>
                        </Tooltip>
                      </TableCell>

                      {/* Mobile Number Cell */}
                      <TableCell
                        align="center"
                        sx={DealershipStyles.tableCellStyle}
                      >
                        <Tooltip
                          title={InputValidation.phoneNumberFormat(
                            user.mobile_number
                          )}
                          placement="top"
                        >
                          <span>
                            {InputValidation.phoneNumberFormat(
                              user.mobile_number
                            )}
                          </span>
                        </Tooltip>
                      </TableCell>

                      {/* Status Cell */}
                      <TableCell align="center" sx={DealershipStyles.userTable}>
                        <Tooltip title="Copy" placement="top">
                          <IconButton
                            onClick={() => {
                              navigator.clipboard.writeText(
                                `${appUrl}/getUserDetails/${JSON.stringify(
                                  user?.employee_user_id
                                )}/${
                                  dealership?.dealership_id
                                }/${JSON.stringify(
                                  user.verification_workflow_id
                                )}`
                              );
                            }}
                          >
                            <ContentCopy color="primary" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>

                      <TableCell align="center" sx={DealershipStyles.userTable}>
                        <IconButton
                          onClick={async () => {
                            await printHandler(user, dealership);
                            handlePrint();
                          }}
                        >
                          <QrCodeScannerOutlined
                            sx={{ color: Theme.palette.primary.main }}
                          />
                        </IconButton>
                      </TableCell>
                      {/* <TableCell
                        align="center"
                        sx={DealershipStyles.tableCellStyle}
                      >
                        {user.assigned_target}
                      </TableCell> */}

                      <TableCell
                        align="center"
                        sx={DealershipStyles.tableCellStyle}
                      >
                        {user.completed}
                      </TableCell>
                      <TableCell align="center" sx={DealershipStyles.userTable}>
                        <Box sx={[DealershipStyles.statusBox]}>
                          <span
                            style={{
                              height: "24px",
                              width: "24px",
                              borderRadius: "12px",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "0.75rem",
                              backgroundColor: user?.is_active
                                ? Theme.palette.primary.main
                                : Theme.palette.error.main,
                            }}
                          ></span>
                        </Box>
                      </TableCell>
                      {/* Actions Cell */}
                      <TableCell align="center" sx={DealershipStyles.userTable}>
                        <IconButton
                          color="inherit"
                          onClick={() => {
                            setEditUser(user);
                            setRefreshChild(false);
                            dialog({
                              open: true,
                              bodyType: TYPE.CREATE_USER,
                              body: (<AddNewUserComponent
                                
                                update={user}
                                setEditUser={setEditUser}
                                   
                                dialog={dialog}
                                isAdminModule={isAdminModule}
                            />),
                              // size: "lg",
                               maxWidth: "lg",
                            });
                          }}
                        >
                          <Edit style={{ color: "darkcyan" }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <Box displayPrint={"block"} display={"none"} ref={printRef}>
                      <QRCodeUtils
                        UserUrl={`${appUrl}/getUserDetails/${JSON.stringify(
                          printUser?.user?.employee_user_id
                        )}/${dealership?.dealership_id}/${JSON.stringify(
                          printUser?.user?.verification_workflow_id
                        )}`}
                        dealershipLogo={dealership?.logo_url}
                        employeeName={`${capitalizeFirstLetter(
                          printUser?.user.first_name
                        )} ${capitalizeFirstLetter(printUser?.user.last_name)}`}
                      />
                    </Box>
                  </>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    sx={{
                      textAlign: "center",
                      border: "none",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    No data to display
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>

        {/* <Paper sx={{ width: "18%", overflow: "scroll", height: "50%" }}>
          {!refreshChild ? (
            <AddNewUserComponent
              update={editUser}
              setEditUser={setEditUser}
              refetch={refetch}
              refresh={refreshChild}
              isAdminModule={isAdminModule}
            />
          ) : (
            <AddNewUserComponent
              refresh={refreshChild}
              isAdminModule={isAdminModule}
            />
          )}
        </Paper> */}
      </Box>
    </Box>
  );
};
export default HocPopup(ManageUsersTable);
